import { ACTION_PARAM } from '../constants/action-params';

export function isActionParamEqualTo(value) {
    const search = new URLSearchParams(location.search);
    const action = search.get(ACTION_PARAM);

    return action === value;
}
